// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Container } from 'semantic-ui-react'

export default class Thanks extends Component {
  render () {
    return (
      <Container className='masterdiv' textAlign='center'>
        <div className='slavediv'>
        <h2>Thank you for your purchase!</h2>
        </div>
      </Container>
    )
  }
}
